import * as React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'

import i18n from '../../services/i18n'
import { ACL } from '../../constants'
import { EstateUtils } from '../../utils'
import { Button, Column, Input, Padding, Modal, UnstyledLink } from '..'
import { NoteButton, Background, ModalTitle } from './Notes.styles'

function Notes(props) {
    const { children, image, noImage, onChange, onChangeImage, onSubmit, title, value } = props

    const [isOpen, setIsOpen] = React.useState(false)
    const canEditNotes = useSelector((state) => EstateUtils.hasPermission(state, { acls: [ACL.STORE_NOTE_EDIT] }))
    const { t } = useTranslation()
    const inputNoteRef = React.useRef()

    React.useEffect(() => {
        if (isOpen && inputNoteRef.current) {
            inputNoteRef.current.focus()
        }
    }, [isOpen])

    const onClose = () => setIsOpen(false)
    const onOpen = () => setIsOpen(!isOpen)

    const onClickSubmit = async () => {
        if (await onSubmit()) {
            onClose()
            onChange({ target: { value: '' } })
        }
    }

    const renderNote = (noteChildren) => (
        <Modal isOpen={isOpen} onClose={onClose}>
            {noteChildren}
        </Modal>
    )

    if (!canEditNotes) {
        return null
    }

    return (
        <>
            <Background show={isOpen} onClick={onClose} />
            {renderNote(
                <div>
                    <ModalTitle>{title}</ModalTitle>
                    <Padding left right size="sm">
                        <Padding top bottom size="xs">
                            <Input
                                ref={inputNoteRef}
                                size="lg"
                                name="note"
                                type="textarea"
                                noresize
                                onChange={onChange}
                                value={value}
                            />
                            {!noImage && (
                                <Input
                                    id="file"
                                    name="file"
                                    type="file"
                                    onChange={onChangeImage}
                                    value={image ? [image] : []}
                                    accept="image/*"
                                />
                            )}
                        </Padding>
                    </Padding>
                    <Padding className="modal-bottom-notes" bottom size="xs">
                        <Column width="100%" right>
                        <Button theme="secondary" size="sm" onClick={onClose}>
                                {t('Cancel')}
                            </Button>
                            <Button theme="forestGreen" size="sm" onClick={onClickSubmit}>
                                {t('Save')}
                            </Button>
                        </Column>
                    </Padding>
                </div>
            )}
            {children && (
                <UnstyledLink onClick={onOpen} to="#" title={title}>
                    {children}
                </UnstyledLink>
            )}
            {!children && (
                <NoteButton onClick={onOpen} title={title}>
                    <FontAwesomeIcon icon="plus" />
                </NoteButton>
            )}
        </>
    )
}

Notes.propTypes = {
    children: PropTypes.node,
    image: PropTypes.shape({}),
    noImage: PropTypes.bool,
    onChange: PropTypes.func,
    onChangeImage: PropTypes.func,
    onSubmit: PropTypes.func,
    title: PropTypes.string,
    value: PropTypes.string,
}

Notes.defaultProps = {
    children: null,
    image: null,
    noImage: false,
    onChange: () => null,
    onChangeImage: () => null,
    onSubmit: () => null,
    title: i18n.t('New Note'),
    value: '',
}

export default Notes
